import { GraduationCap, ArrowRight, BookOpen, Award, Calendar, Sparkles, Gift, Plane, Globe, Briefcase, Users2, Target, Megaphone, Bot, Video, Handshake, Rocket, Hotel, FileText, Download, Search, X, ScrollText, DollarSign, TrendingDown, Clock, AlertTriangle, CheckCircle2, ShieldCheck, Bell, FileCheck, Umbrella, PlayCircle, ChevronDown, Mic } from "lucide-react";
import { useState, useEffect } from "react";
import { Lock } from "lucide-react";
import { API_URL } from "../config/api";
import { MoneyVideosSection } from "./MoneyVideosSection";
import { ZoomRecordingsSection } from "./ZoomRecordingsSection";

const ACADEMIA_PASSWORD = process.env.REACT_APP_ACADEMIA_PASSWORD || "012345CARLOS";

const AcademiaGate = ({ onUnlock }) => {
  const [pass, setPass] = useState("");
  const [error, setError] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (ACADEMIA_PASSWORD && pass.trim() === ACADEMIA_PASSWORD) {
      sessionStorage.setItem("academia_unlocked", "1");
      onUnlock();
    } else {
      setError(true);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-[#0D1B2A] via-[#13132a] to-[#0a0a14]"
      style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}
      data-testid="academia-gate"
    >
      <div className="w-full max-w-md bg-[#0f0f1e]/80 border border-[#C9A84C]/30 rounded-3xl p-8 sm:p-10 text-center backdrop-blur-xl shadow-2xl">
        <div className="mx-auto mb-6 w-16 h-16 rounded-2xl bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center">
          <Lock className="h-7 w-7 text-[#C9A84C]" />
        </div>
        <p className="text-[11px] uppercase tracking-[3px] font-mono text-[#C9A84C] mb-3">Acceso privado</p>
        <h1 className="text-2xl sm:text-3xl font-black text-white mb-2">Universidad Travel Empire</h1>
        <p className="text-sm text-white/60 mb-7">Ingresa la clave de acceso para ver el contenido de la academia.</p>
        <form onSubmit={submit} className="space-y-4">
          <input
            type="password"
            value={pass}
            onChange={(e) => { setPass(e.target.value); setError(false); }}
            placeholder="Clave de acceso"
            autoFocus
            data-testid="academia-password-input"
            className="w-full bg-[#0a0a14] border border-[#C9A84C]/30 focus:border-[#C9A84C] text-white text-center tracking-widest rounded-xl px-4 py-3 outline-none transition-colors placeholder:text-white/30"
          />
          {error && (
            <p className="text-sm text-red-400 font-semibold" data-testid="academia-password-error">
              Clave incorrecta. Intenta de nuevo.
            </p>
          )}
          <button
            type="submit"
            data-testid="academia-password-submit"
            className="w-full bg-gradient-to-r from-[#C9A84C] via-[#E0B835] to-[#C9A84C] text-[#0a0a14] font-black py-3 rounded-xl hover:opacity-90 transition-opacity"
          >
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
};


const CURSOS = [
  {
    secreto: "Secreto #1",
    icon: Plane,
    accent: "#C9A84C",
    title: "El Paquete del Millón",
    subtitle: "Certificados de Viaje",
    description:
      "El curso que ha generado más millonarios en la industria turística. Pitch perfecto, prospección por Facebook y WhatsApp, y las 8 objeciones más frecuentes con sus cierres.",
    modulos: 5,
    leccion_count: "El Paquete · El Pitch · Prospección · Ingresos · Fórmulas",
    temas: ["Certificados de viaje", "Orlando", "Miami", "Convertidores a $2", "El pitch perfecto", "Prospección por Facebook", "Prospección por WhatsApp", "8 objeciones y sus cierres", "Plan de ingresos", "Fórmula 100/30/10", "Guiones telefónicos", "Calificaciones por certificado", "Gran Sirenis", "Punta Cana", "Cancún", "Tenerife", "Plataforma certiviaje.com", "Examen de certificación", "Prospección mayorista TV y radio"],
    href: "/cursoelpaquetedelmillon",
    badge: "Más vendido",
  },
  {
    secreto: "Secreto #2",
    icon: Globe,
    accent: "#45A0EE",
    title: "Visa con Éxito",
    subtitle: "Asesorías Migratorias",
    description:
      "El mercado migratorio más grande de LATAM. Las 7 preguntas de descubrimiento, los 3 tipos de prospectos, y las 10 objeciones tipo con sus cierres exactos.",
    modulos: 4,
    leccion_count: "El producto · Conoce a tu cliente · Prospección · Venta y cierre",
    temas: ["Visa americana", "Asesoría migratoria", "7 preguntas de descubrimiento", "3 tipos de prospectos", "10 objeciones migratorias con cierre", "Conoce a tu cliente", "Venta y cierre", "Mercado migratorio LATAM"],
    href: "/cursovisaconexito",
    badge: "Alta demanda",
  },
  {
    secreto: "Secreto #3",
    icon: Briefcase,
    accent: "#80C753",
    title: "Academia B2B",
    subtitle: "Plataformas Profesionales",
    description:
      "Certifícate en RateHawk, nuestra plataforma B2B de hoteles con sistema de sub-agencias. Examen final + sello \"Agente B2B Certificado\".",
    modulos: 10,
    leccion_count: "RateHawk · Sub-agencias · Cotización + Examen",
    temas: ["RateHawk", "Plataforma B2B de hoteles", "Sub-agencias", "Cotización de hoteles", "Reservas de hoteles", "Examen final", "Agente B2B certificado", "Video tutorial de RateHawk"],
    href: "/cursoacademiab2b",
    badge: "Con certificación",
  },
  {
    secreto: "Secreto #4",
    icon: Award,
    accent: "#C9A84C",
    title: "Curso Profesional de Ventas",
    subtitle: "Club Vacacional Digital",
    description:
      "El producto más rentable: ARDA reportó $23,160 por transacción promedio en 2024. Proceso de 15 pasos, venta online y presencial, 8 objeciones con cierre.",
    modulos: 4,
    leccion_count: "Fundamentos · Proceso 15 pasos · Canales · Objeciones",
    temas: ["Club vacacional", "Membresías vacacionales", "Proceso de 15 pasos", "Venta online", "Venta presencial", "8 objeciones con cierre", "ARDA", "Alto ticket", "Simulador de club vacacional"],
    href: "/cursoclubvacacional",
    badge: "Alto ticket",
  },
  {
    secreto: "Secreto #5",
    icon: Users2,
    accent: "#80C753",
    title: "El Poder de Referir",
    subtitle: "Embajador Digital",
    description:
      "Comisión según tu plan (Starter 50, Duo 55, Profesional 60 y Travel Empire 80%) por compartir la oportunidad. Nunca fue tan fácil ganar en altos volúmenes: solo invita personas a nuestros webinars. URL Hotmart, 2 salas digitales semanales, regla del 25% y calculadora en vivo.",
    modulos: 8,
    leccion_count: "Eventos · URL Hotmart · Comisiones · Calculadora · Plan de acción",
    temas: ["Referidos", "Embajador digital", "Comisiones por plan", "URL de Hotmart", "Webinars", "Salas digitales semanales", "Regla del 25%", "Calculadora de comisiones", "Plan de acción", "Invitar a webinars"],
    href: "/cursoreferidos",
    badge: "Comisión hasta 80%",
  },
];

// Categoría adicional: cursos de prospección (no atados a un Secreto específico)
const CURSOS_PROSPECTAR = [
  {
    id: "videoacademy",
    icon: Video,
    accent: "#EF4444",
    title: "Video Academy",
    subtitle: "Vende con video — TikTok, Reels y YouTube",
    description:
      "El curso completo para crear contenido en video que atrae prospectos calificados. Guiones probados, ganchos virales, edición rápida con el celular y secuencias para convertir vistas en reuniones.",
    modulos: "Curso completo",
    leccion_count: "Guiones · Ganchos · Edición móvil · TikTok/Reels · Conversión",
    temas: ["Video marketing", "TikTok", "Reels", "YouTube", "Guiones de video", "Ganchos virales", "Edición con el celular", "Convertir vistas en reuniones"],
    href: "/videoacademy",
    badge: "Nuevo",
  },
  {
    id: "cierremaestro",
    icon: Handshake,
    accent: "#C9A84C",
    title: "Cierre Maestro",
    subtitle: "Sales Academy — Cómo cerrar más ventas",
    description:
      "El arte y la ciencia del cierre profesional. Técnicas para manejar objeciones, leer señales de compra, generar urgencia legítima y convertir prospectos indecisos en clientes firmados.",
    modulos: "Curso completo",
    leccion_count: "Objeciones · Señales · Urgencia · Cierres · Negociación",
    temas: ["Cierre de ventas", "Manejo de objeciones", "Señales de compra", "Urgencia legítima", "Técnicas de cierre", "Negociación", "Prospectos indecisos"],
    href: "/cierremaestro",
    badge: "Nuevo",
  },
  {
    id: "guiones-setter",
    icon: Mic,
    accent: "#EAB308",
    title: "Guiones de Locución — Línea de Setter",
    subtitle: "Scripts + audios para WhatsApp",
    description:
      "La colección oficial de guiones de locución para setters: cada script con su texto listo para copiar y su grabación de audio para descargar y enviar por WhatsApp. Todos dirigen a tu prospecto al webinar en vivo.",
    modulos: "Uso exclusivo del equipo",
    leccion_count: "Guiones · Audios · Objeciones · Invitación a webinar",
    temas: ["Guiones de locución", "Scripts para WhatsApp", "Audios de setter", "Línea de setter", "Invitar al webinar", "La magia del primer contacto", "La biblia del setter", "Objeciones por audio", "Prospección por WhatsApp"],
    href: "/solousosettersprivado2026",
    badge: "Uso interno setters",
  },
  {
    id: "guiones-venta",
    icon: ScrollText,
    accent: "#C9A84C",
    title: "Guiones de Venta",
    subtitle: "Venta directa de la agencia — antes del webinar",
    description:
      "El guion de demostración paso a paso para presentar y vender tu agencia en 35-40 minutos por Zoom o Meet. Incluye apertura, los 5 secretos, demo de plataformas, el sistema de GHL, el plan de compensación y el cierre, con cada frase lista para copiar, las preguntas de control y la tabla de objeciones.",
    modulos: "Guion completo · 8 secciones",
    leccion_count: "Apertura · 5 secretos · Demo · GHL · Compensación · Cierre · Objeciones",
    temas: ["Venta directa", "Demostración de la agencia", "Guion de webinar", "5 secretos de la industria", "Plan de compensación", "Override y bono de registro", "Cierre de ventas", "Manejo de objeciones", "Programa Despegue"],
    href: "/guiondeventaagencia",
    badge: "Nuevo",
  },
];

const Stat = ({ value, label }) => (
  <div className="text-center">
    <p className="text-3xl sm:text-5xl font-black text-[#C9A84C] leading-none">{value}</p>
    <p className="text-[10px] sm:text-xs text-slate-400 uppercase tracking-wider mt-2">{label}</p>
  </div>
);

const CursoCard = ({ curso, query = "" }) => {
  const Icon = curso.icon;
  const temasHit = matchedTemas(curso, norm(query.trim()));
  const testid = curso.secreto
    ? curso.secreto.replace(/\s|#/g, "-").toLowerCase()
    : curso.id || curso.title.replace(/\s+/g, "-").toLowerCase();
  return (
    <a
      href={curso.href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`academia-curso-${testid}`}
      className="group block bg-gradient-to-br from-[#13132a] via-[#1a1a2e] to-[#13132a] border border-white/10 hover:border-[#C9A84C]/50 rounded-2xl p-6 transition-all hover:shadow-[0_20px_60px_rgba(201,168,76,0.18)] hover:-translate-y-1"
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div
          className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 border"
          style={{ backgroundColor: `${curso.accent}1F`, borderColor: `${curso.accent}66` }}
        >
          <Icon className="h-7 w-7" style={{ color: curso.accent }} />
        </div>
        {curso.badge && (
          <span
            className="text-[9px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full border"
            style={{ backgroundColor: `${curso.accent}1A`, color: curso.accent, borderColor: `${curso.accent}55` }}
          >
            {curso.badge}
          </span>
        )}
      </div>

      <p className="text-[10px] font-mono uppercase tracking-[2px] mb-1" style={{ color: curso.accent }}>
        {curso.secreto ? `${curso.secreto} · ${curso.subtitle}` : curso.subtitle}
      </p>
      <h3 className="text-xl sm:text-2xl font-black text-white leading-tight mb-3 group-hover:text-[#C9A84C] transition-colors">
        {curso.title}
      </h3>
      <p className="text-sm text-slate-300 leading-relaxed mb-4">{curso.description}</p>

      <div className="flex items-center gap-2 text-xs text-slate-400 mb-4">
        <BookOpen className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="font-semibold">{typeof curso.modulos === "number" ? `${curso.modulos} módulos` : curso.modulos}</span>
        <span className="text-slate-600">·</span>
        <span className="truncate">{curso.leccion_count}</span>
      </div>

      {temasHit.length > 0 && (
        <div className="mb-4" data-testid={`academia-temas-${testid}`}>
          <p className="text-[10px] font-mono uppercase tracking-[2px] text-[#C9A84C] mb-2">Contiene lo que buscas:</p>
          <div className="flex flex-wrap gap-1.5">
            {temasHit.slice(0, 5).map((t) => (
              <span
                key={t}
                className="inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-md border"
                style={{ backgroundColor: `${curso.accent}1A`, color: curso.accent, borderColor: `${curso.accent}55` }}
              >
                <Search className="h-2.5 w-2.5" />{t}
              </span>
            ))}
          </div>
        </div>
      )}

      <div
        className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider group-hover:gap-3 transition-all"
        style={{ color: curso.accent }}
      >
        Abrir curso <ArrowRight className="h-4 w-4" />
      </div>
    </a>
  );
};

const norm = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

// Distancia de edición (tolerancia a errores de tipeo)
const lev = (a, b) => {
  const m = a.length, n = b.length;
  if (Math.abs(m - n) > 2) return 99;
  const dp = Array.from({ length: m + 1 }, (_, i) => i);
  for (let j = 1; j <= n; j++) {
    let prev = dp[0]; dp[0] = j;
    for (let i = 1; i <= m; i++) {
      const tmp = dp[i];
      dp[i] = Math.min(dp[i] + 1, dp[i - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = tmp;
    }
  }
  return dp[m];
};

const wordScore = (word, tok) => {
  if (word === tok) return 4;
  if (word.includes(tok)) return tok.length >= 4 ? 3 : 2;
  if (word.startsWith(tok) && tok.length >= 3) return 2;
  if (tok.length >= 4 && lev(word, tok) <= 1) return 2;
  if (tok.length >= 5 && lev(word, tok) <= 2) return 1;
  return 0;
};

// Puntúa qué tan bien un texto coincide con la búsqueda (0 = nada)
const scoreText = (text, q) => {
  const t = norm(text);
  const nq = norm(q);
  if (!nq) return 0;
  const words = t.split(/\s+/).filter(Boolean);
  const tokens = nq.split(/\s+/).filter(Boolean);
  let total = 0, matched = 0;
  for (const tok of tokens) {
    let best = t.includes(tok) ? 2 : 0;
    for (const w of words) best = Math.max(best, wordScore(w, tok));
    if (best > 0) matched++;
    total += best;
  }
  if (matched === 0) return 0;
  if (t.startsWith(nq)) total += 3;
  if (matched === tokens.length) total += tokens.length;
  return total;
};

const cursoHay = (c) => [c.title, c.subtitle, c.description, c.leccion_count, c.secreto, c.badge, (c.temas || []).join(" ")].join(" ");
const cursoScore = (c, q) => scoreText(cursoHay(c), q);
const matchCurso = (c, q) => (!q ? true : cursoScore(c, q) > 0);

const matchedTemas = (c, q) => {
  if (!q) return [];
  return (c.temas || [])
    .map((t) => ({ t, s: scoreText(t, q) }))
    .filter((x) => x.s > 0)
    .sort((a, b) => b.s - a.s)
    .map((x) => x.t);
};

// Índice de sugerencias para el autocompletar (cursos + temas)
const ALL_CURSOS = [...CURSOS, ...CURSOS_PROSPECTAR];

// Metadatos por curso/secreto para agrupar grabaciones (título + color)
const SECRETO_META = ALL_CURSOS.reduce((acc, c) => {
  if (c.secreto) acc[c.secreto] = { title: c.title, subtitle: c.subtitle, accent: c.accent, href: c.href };
  return acc;
}, {});

const SUGGESTION_INDEX = (() => {
  const out = [];
  const seen = new Set();
  ALL_CURSOS.forEach((c) => {
    out.push({ type: "curso", label: c.title, sub: c.subtitle, href: c.href, accent: c.accent });
    (c.temas || []).forEach((t) => {
      const key = norm(t);
      if (seen.has(key)) return;
      seen.add(key);
      out.push({ type: "tema", label: t, sub: c.title, href: c.href, accent: c.accent });
    });
  });
  return out;
})();

const getSuggestions = (q, limit = 8) => {
  const nq = norm(q.trim());
  if (nq.length < 2) return [];
  return SUGGESTION_INDEX
    .map((s) => ({ ...s, score: scoreText(s.label, q) + (s.type === "curso" ? 1 : 0) }))
    .filter((s) => s.score > 0)
    .sort((a, b) => b.score - a.score || a.label.length - b.label.length)
    .slice(0, limit);
};

// Tarjeta plegable: solo muestra título + explicación; el contenido se abre al hacer clic
const AccordionCard = ({ Icon, accent, badge, title, desc, open, onToggle, testid }) => (
  <button
    type="button"
    onClick={onToggle}
    data-testid={testid}
    aria-expanded={open}
    className="group w-full text-left block bg-gradient-to-br from-[#13132a] via-[#1a1a2e] to-[#13132a] border-2 rounded-xl p-5 transition-all hover:shadow-[0_10px_40px_rgba(0,0,0,0.35)] hover:-translate-y-0.5"
    style={{ borderColor: open ? `${accent}` : `${accent}55` }}
  >
    <div className="flex items-center gap-4">
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 border"
        style={{ backgroundColor: `${accent}1F`, borderColor: `${accent}66` }}
      >
        <Icon className="h-6 w-6" style={{ color: accent }} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-[10px] font-mono tracking-[2px] uppercase mb-1" style={{ color: accent }}>{badge}</p>
        <h4 className="text-base sm:text-lg font-bold text-white leading-tight mb-1">{title}</h4>
        <p className="text-xs sm:text-sm text-slate-300 leading-snug">{desc}</p>
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0 font-bold text-xs uppercase tracking-wider" style={{ color: accent }}>
        <span className="hidden sm:inline">{open ? "Cerrar" : "Abrir"}</span>
        <ChevronDown className={`h-5 w-5 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </div>
    </div>
  </button>
);

// Escala de degradación de comisión (Sección 9)
const ESCALA = [
  { dias: "Día 0 – 7", pct: "100%", nivel: "ok", nota: "Propiedad total, mientras haya contacto documentado" },
  { dias: "Día 14", pct: "85%", nivel: "warn", nota: "Primera señal de descuido — ya sonó la alerta del día 7" },
  { dias: "Día 21", pct: "70%", nivel: "warn", nota: "Segunda advertencia — el lead empieza a estar en riesgo real" },
  { dias: "Día 30", pct: "50%", nivel: "mid", nota: "1 mes — la IA de la empresa ya gestiona activamente este lead" },
  { dias: "Día 37", pct: "35%", nivel: "mid", nota: "El descuento se acelera" },
  { dias: "Día 45", pct: "20%", nivel: "bad", nota: "Ausencia prolongada de contacto" },
  { dias: "Día 52", pct: "10%", nivel: "bad", nota: "Última alerta antes del piso" },
  { dias: "Día 60+", pct: "5%", nivel: "floor", nota: "Lead gestionado 100% por la IA; el resto queda para la empresa" },
];
const NIVEL_STYLE = {
  ok: { row: "bg-[#16A34A]/10", pct: "text-[#4ADE80]" },
  warn: { row: "bg-[#EAB308]/10", pct: "text-[#FBBF24]" },
  mid: { row: "bg-[#F97316]/10", pct: "text-[#FB923C]" },
  bad: { row: "bg-[#EF4444]/10", pct: "text-[#F87171]" },
  floor: { row: "bg-[#7F1D1D]/25", pct: "text-[#FCA5A5]" },
};

const TECH_COSTS = [
  { rec: "Llamada del Agente de Voz IA (por minuto)", cost: "$0.08 – $0.15 USD / min" },
  { rec: "Mensaje de WhatsApp Business API", cost: "$0.01 – $0.04 USD / msj" },
  { rec: "SMS", cost: "$0.008 – $0.05 USD / msj, según país" },
  { rec: "Email masivo", cost: "Bajo por mensaje, se acumula con el volumen" },
  { rec: "Licencia mensual plataforma (CRM + IA)", cost: "Cientos de USD/mes, fijo" },
];

const LeadsTerminosSection = () => (
  <section className="px-4 py-14 sm:py-20" data-testid="academia-terminos-leads" id="terminos-leads">
    <div className="max-w-5xl mx-auto">
      {/* Encabezado destacado */}
      <div className="relative overflow-hidden rounded-3xl border-2 border-[#C9A84C]/50 bg-gradient-to-br from-[#1a1408] via-[#13132a] to-[#0a0a14] p-7 sm:p-10 mb-8 shadow-[0_20px_60px_rgba(201,168,76,0.18)]">
        <div className="absolute -top-16 -right-16 w-72 h-72 bg-[#C9A84C]/20 rounded-full blur-[120px] pointer-events-none" />
        <div className="relative">
          <div className="inline-flex items-center gap-2 bg-[#C9A84C]/15 border border-[#C9A84C]/50 text-[#E0B835] px-3.5 py-1.5 rounded-full text-[11px] font-black uppercase tracking-[2px] mb-5">
            <ScrollText className="h-4 w-4" /> Lectura obligatoria · Todos los agentes
          </div>
          <h2 className="text-3xl sm:text-5xl font-black text-white leading-[0.98] mb-4">
            Términos y Condiciones<br />
            <span className="text-[#C9A84C]">Propiedad y Seguimiento de Leads</span>
          </h2>
          <p className="text-sm sm:text-base text-slate-300 leading-relaxed max-w-3xl">
            Aplica a todos los <strong className="text-white">Appointment Setters / Agentes</strong> que reciben leads asignados dentro del sistema de Club Viajemos. Léelo con atención: aquí se define cómo se gana —y cómo se pierde— la comisión de cada lead.
          </p>
        </div>
      </div>

      {/* 1. Principio general */}
      <div className="rounded-2xl border border-[#C9A84C]/30 bg-gradient-to-br from-[#13132a] to-[#0a0a14] p-6 sm:p-7 mb-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#C9A84C] text-[#0a0a14] font-black flex items-center justify-center">1</span>
          <h3 className="text-lg sm:text-xl font-black text-white">Principio general</h3>
        </div>
        <p className="text-sm text-slate-300 leading-relaxed mb-3">
          Ser asignado como <strong className="text-white">propietario de un lead</strong> no es un título pasivo ni una garantía automática de comisión. Ser propietario significa asumir la <strong className="text-[#C9A84C]">responsabilidad activa</strong> de contactar a ese cliente, trabajarlo y darle seguimiento constante hasta el cierre.
        </p>
        <p className="text-sm text-slate-400 leading-relaxed">
          No está permitido que un lead genere comisión completa para un agente que no lo trabajó. <strong className="text-white">La comisión se gana con el seguimiento — no solo con la asignación inicial.</strong>
        </p>
      </div>

      {/* 2. Qué cubre el valor pagado */}
      <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-[#13132a] to-[#0a0a14] p-6 sm:p-7 mb-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#45A0EE] text-[#0a0a14] font-black flex items-center justify-center">2</span>
          <h3 className="text-lg sm:text-xl font-black text-white">Qué cubre el valor pagado por el lead</h3>
        </div>
        <p className="text-sm text-slate-300 leading-relaxed mb-4">
          El pago del agente cubre <strong className="text-white">únicamente el costo de generación del lead</strong> (lo que costó captarlo). <strong className="text-white">No cubre</strong> la automatización, la inteligencia artificial, las llamadas del equipo de IA ni los recursos que mantienen el lead activo mientras el agente no lo trabaja. Ese costo lo asume la empresa.
        </p>
        <div className="grid sm:grid-cols-2 gap-3">
          <div className="rounded-xl border border-[#16A34A]/30 bg-[#16A34A]/10 p-4">
            <div className="flex items-center gap-2 mb-1.5"><CheckCircle2 className="h-4 w-4 text-[#4ADE80]" /><p className="text-xs font-bold text-[#4ADE80] uppercase tracking-wider">Tú cierras → tú ganas</p></div>
            <p className="text-sm text-slate-300 leading-relaxed">Si contactaste, llamaste, perseguiste e impulsaste al cliente, <strong className="text-white">la venta y su comisión completa son tuyas</strong>. El esfuerzo y el resultado son tuyos.</p>
          </div>
          <div className="rounded-xl border border-[#EF4444]/30 bg-[#EF4444]/10 p-4">
            <div className="flex items-center gap-2 mb-1.5"><TrendingDown className="h-4 w-4 text-[#F87171]" /><p className="text-xs font-bold text-[#F87171] uppercase tracking-wider">Dejas de trabajarlo → se degrada</p></div>
            <p className="text-sm text-slate-300 leading-relaxed">Si dejas de dar contacto humano y la IA de la empresa genera el interés que cierra la venta, aplica la <strong className="text-white">degradación de comisión</strong> (Sección 9).</p>
          </div>
        </div>
      </div>

      {/* 3. Costo real de la tecnología */}
      <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-[#13132a] to-[#0a0a14] p-6 sm:p-7 mb-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#A855F7] text-white font-black flex items-center justify-center">3</span>
          <h3 className="text-lg sm:text-xl font-black text-white">El costo real de la tecnología que sostiene cada lead</h3>
        </div>
        <p className="text-sm text-slate-300 leading-relaxed mb-4">
          Club Viajemos es una <strong className="text-white">inversión real en tecnología</strong> detrás de cada lead. Cifras de referencia de la industria en 2026 (no una factura exacta), para entender el orden de magnitud:
        </p>
        <div className="overflow-x-auto rounded-xl border border-white/10 mb-4">
          <table className="w-full text-sm border-collapse" data-testid="terminos-tech-tabla">
            <thead>
              <tr className="bg-white/[0.04] text-white">
                <th className="text-left font-bold px-4 py-3 border-b border-white/10">Recurso tecnológico</th>
                <th className="text-left font-bold px-4 py-3 border-b border-white/10">Costo aprox. en la industria</th>
              </tr>
            </thead>
            <tbody className="text-slate-300">
              {TECH_COSTS.map((r) => (
                <tr key={r.rec} className="odd:bg-white/[0.02]">
                  <td className="px-4 py-3 border-b border-white/5">{r.rec}</td>
                  <td className="px-4 py-3 border-b border-white/5 font-semibold text-white whitespace-nowrap">{r.cost}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex items-start gap-2 bg-[#A855F7]/10 border border-[#A855F7]/25 rounded-xl p-3.5">
          <DollarSign className="h-4 w-4 text-[#C084FC] flex-shrink-0 mt-0.5" />
          <p className="text-sm text-slate-200 leading-relaxed">
            Un solo lead con nutrición diaria por 30 días + una llamada de 3 min con el Agente de Voz IA + recordatorios puede costar <strong className="text-white">$2 a $5 USD en tecnología</strong>. Esa inversión la hace la empresa <strong className="text-[#E0B835]">para que TÚ generes dinero</strong> — pero solo rinde si pones tu tiempo y determinación.
          </p>
        </div>
      </div>

      {/* 4 + 8. Ser propietario / requisito mínimo */}
      <div className="grid sm:grid-cols-2 gap-5 mb-5">
        <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-[#13132a] to-[#0a0a14] p-6">
          <div className="flex items-center gap-3 mb-3">
            <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#C9A84C] text-[#0a0a14] font-black flex items-center justify-center">4</span>
            <h3 className="text-base font-black text-white leading-tight">Qué significa "ser propietario"</h3>
          </div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-[#C9A84C] flex-shrink-0 mt-0.5" /> Contactar al cliente en las primeras <strong className="text-white">24 horas</strong> tras la asignación.</li>
            <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-[#C9A84C] flex-shrink-0 mt-0.5" /> Registrar cada intento (llamada, WhatsApp, correo) con fecha y resultado.</li>
            <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-[#C9A84C] flex-shrink-0 mt-0.5" /> Seguimiento activo y constante — no un solo intento aislado.</li>
            <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-[#C9A84C] flex-shrink-0 mt-0.5" /> Responder con la información, calidez y ritmo que el cliente necesita.</li>
          </ul>
        </div>
        <div className="rounded-2xl border border-[#16A34A]/30 bg-gradient-to-br from-[#0a1a10] to-[#0a0a14] p-6">
          <div className="flex items-center gap-3 mb-3">
            <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#16A34A] text-white font-black flex items-center justify-center">8</span>
            <h3 className="text-base font-black text-white leading-tight">Requisito mínimo de seguimiento</h3>
          </div>
          <p className="text-sm text-slate-300 leading-relaxed mb-3">
            Para conservar el <strong className="text-[#4ADE80]">100% de la propiedad</strong> (y su comisión completa), mantén <strong className="text-white">al menos un contacto documentado cada 7 días</strong>.
          </p>
          <div className="flex items-start gap-2 bg-[#16A34A]/10 border border-[#16A34A]/25 rounded-lg p-3">
            <ShieldCheck className="h-4 w-4 text-[#4ADE80] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-200 leading-relaxed">El conteo <strong className="text-white">no depende de si el cliente responde</strong>, sino de si TÚ intentaste el contacto. Un cliente lento no te hace perder el lead si queda registrado que lo intentaste.</p>
          </div>
        </div>
      </div>

      {/* 9. ESCALA DE DEGRADACIÓN — LO MÁS IMPORTANTE */}
      <div className="rounded-2xl border-2 border-[#EF4444]/40 bg-gradient-to-br from-[#1a0d0d] via-[#13132a] to-[#0a0a14] p-6 sm:p-7 mb-5" data-testid="terminos-escala">
        <div className="flex items-center gap-3 mb-3">
          <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#EF4444] text-white font-black flex items-center justify-center">9</span>
          <h3 className="text-lg sm:text-xl font-black text-white">Escala de degradación de comisión por falta de seguimiento</h3>
        </div>
        <p className="text-sm text-slate-300 leading-relaxed mb-5">
          En vez de una pérdida total y repentina, aplicamos una <strong className="text-white">escala gradual</strong> según los días sin ningún intento de contacto documentado:
        </p>
        {/* EXCEPCIÓN CLAVE — el mismo agente cierra */}
        <div className="rounded-xl border-2 border-[#16A34A]/50 bg-[#16A34A]/10 p-4 sm:p-5 mb-5 flex items-start gap-3" data-testid="terminos-excepcion-agente">
          <ShieldCheck className="h-6 w-6 text-[#4ADE80] flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-[11px] text-[#4ADE80] font-black uppercase tracking-[2px] mb-1">Excepción clave · Tú cierras, tú cobras el 100%</p>
            <p className="text-sm text-slate-100 leading-relaxed">
              Nada de esta escala entra en vigor <strong className="text-white">si es el mismo agente quien realiza la venta</strong>. Aunque hayas perdido espacios de tiempo de contactabilidad con el lead, si al final <strong className="text-white">tú cierras la venta, se te paga tu comisión completa</strong>. La degradación solo aplica cuando la venta la genera la IA/automatización de la empresa por tu ausencia de contacto — nunca cuando el cierre lo haces tú.
            </p>
          </div>
        </div>
        <div className="overflow-x-auto rounded-xl border border-white/10">
          <table className="w-full text-sm border-collapse" data-testid="terminos-escala-tabla">
            <thead>
              <tr className="bg-white/[0.04] text-white">
                <th className="text-left font-bold px-4 py-3 border-b border-white/10 whitespace-nowrap">Días sin contacto</th>
                <th className="text-left font-bold px-4 py-3 border-b border-white/10 whitespace-nowrap">Comisión que conservas</th>
                <th className="text-left font-bold px-4 py-3 border-b border-white/10">Qué significa</th>
              </tr>
            </thead>
            <tbody>
              {ESCALA.map((e) => {
                const st = NIVEL_STYLE[e.nivel];
                return (
                  <tr key={e.dias} className={st.row}>
                    <td className="px-4 py-3 border-b border-white/5 font-semibold text-white whitespace-nowrap">{e.dias}</td>
                    <td className={`px-4 py-3 border-b border-white/5 font-black text-lg ${st.pct} whitespace-nowrap`}>{e.pct}</td>
                    <td className="px-4 py-3 border-b border-white/5 text-slate-300">{e.nota}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="grid sm:grid-cols-2 gap-3 mt-5">
          <div className="flex items-start gap-2 bg-white/[0.03] border border-white/10 rounded-xl p-3.5">
            <Clock className="h-4 w-4 text-[#C9A84C] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-300 leading-relaxed"><strong className="text-white">Empieza suave y se acelera:</strong> en viajes el cliente a veces tarda semanas por razones legítimas. No se castiga al agente paciente — solo a quien dejó de intentar. Por eso el descuento es leve las primeras 3 semanas y se acelera tras el día 30.</p>
          </div>
          <div className="flex items-start gap-2 bg-white/[0.03] border border-white/10 rounded-xl p-3.5">
            <ShieldCheck className="h-4 w-4 text-[#4ADE80] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-300 leading-relaxed"><strong className="text-white">Piso del 5% (no 0%):</strong> reconoce que originaste el contacto inicial, aunque no cerraras. Todos los porcentajes se calculan sobre la <strong className="text-white">comisión total del lead</strong>, no sobre su valor.</p>
          </div>
        </div>
        <p className="text-xs text-slate-400 leading-relaxed mt-4">
          Cuando dejas de contactar, la IA y automatización de la empresa (no otro agente humano) retoman la comunicación. Si esa gestión automatizada cierra la venta, la porción de comisión liberada según la tabla queda en beneficio de la empresa, porque fue su sistema —con su propio costo— el que generó el resultado.
        </p>
      </div>

      {/* 10. Alertas preventivas */}
      <div className="rounded-2xl border border-[#EAB308]/30 bg-gradient-to-br from-[#1a1608] to-[#0a0a14] p-6 mb-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#EAB308] text-[#0a0a14] font-black flex items-center justify-center">10</span>
          <h3 className="text-base sm:text-lg font-black text-white">Alertas preventivas</h3>
          <Bell className="h-5 w-5 text-[#FBBF24] ml-auto" />
        </div>
        <p className="text-sm text-slate-300 leading-relaxed">
          Para que ningún agente pierda comisión por descuido, el sistema envía recordatorios automáticos <strong className="text-white">antes de cada caída de porcentaje</strong> (días 7, 14, 21, 30, 37, 45 y 52). Siempre tienes la oportunidad de actuar antes del siguiente descuento.
        </p>
      </div>

      {/* 5, 6, 7 — contexto */}
      <div className="grid sm:grid-cols-3 gap-4 mb-5">
        <div className="rounded-2xl border border-white/10 bg-[#13132a] p-5">
          <span className="inline-flex w-7 h-7 rounded-lg bg-white/10 text-white font-black text-sm items-center justify-center mb-3">5</span>
          <h4 className="text-sm font-bold text-white mb-2">Por qué existe un plazo</h4>
          <p className="text-xs text-slate-400 leading-relaxed">Facebook (Meta) elimina los datos de un lead a los <strong className="text-white">90 días</strong>. Aquí el dato no se pierde: se pierde progresivamente la atención prioritaria y la comisión que la empresa dedica a través de su agente.</p>
        </div>
        <div className="rounded-2xl border border-white/10 bg-[#13132a] p-5">
          <span className="inline-flex w-7 h-7 rounded-lg bg-white/10 text-white font-black text-sm items-center justify-center mb-3">6</span>
          <h4 className="text-sm font-bold text-white mb-2">El verdadero valor de un lead</h4>
          <p className="text-xs text-slate-400 leading-relaxed">No está en lo que cuesta, sino en <strong className="text-white">lo que se pierde cuando no se trabaja</strong>: la oportunidad del cliente, su confianza y la reputación de toda la empresa.</p>
        </div>
        <div className="rounded-2xl border border-[#C9A84C]/30 bg-gradient-to-br from-[#1a1408] to-[#13132a] p-5">
          <div className="flex items-center gap-2 mb-3">
            <span className="inline-flex w-7 h-7 rounded-lg bg-[#C9A84C] text-[#0a0a14] font-black text-sm items-center justify-center">7</span>
            <Users2 className="h-4 w-4 text-[#E0B835]" />
          </div>
          <h4 className="text-sm font-bold text-white mb-2">El factor panal de abeja</h4>
          <p className="text-xs text-slate-400 leading-relaxed">Si una abeja deja de trabajar, se debilita <strong className="text-white">toda la estructura</strong>. Igual en el equipo: cumplir estos términos defiende el bien común de Club Viajemos, no solo una regla individual.</p>
        </div>
      </div>

      {/* 11, 12 verificación */}
      <div className="grid sm:grid-cols-2 gap-5 mb-5">
        <div className="rounded-2xl border border-white/10 bg-[#13132a] p-6">
          <div className="flex items-center gap-3 mb-2">
            <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#45A0EE] text-[#0a0a14] font-black flex items-center justify-center">11</span>
            <h3 className="text-base font-black text-white">Verificación</h3>
          </div>
          <p className="text-sm text-slate-300 leading-relaxed">Todo el historial de contacto (llamadas, mensajes, notas) debe quedar en el <strong className="text-white">CRM de la empresa</strong>. Es la única fuente válida para determinar si un lead fue trabajado o abandonado en caso de disputa.</p>
        </div>
        <div className="rounded-2xl border border-white/10 bg-[#13132a] p-6">
          <div className="flex items-center gap-3 mb-2">
            <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#45A0EE] text-[#0a0a14] font-black flex items-center justify-center">12</span>
            <h3 className="text-base font-black text-white">Verificación en el onboarding</h3>
          </div>
          <p className="text-sm text-slate-300 leading-relaxed">En cada onboarding del nuevo agente pedimos <strong className="text-white">constancia del trabajo del setter</strong>: cómo lo contactó y qué seguimiento recibió. Es control de comisiones y, sobre todo, retroalimentación real para mejorar como equipo.</p>
        </div>
      </div>

      {/* 13. Aceptación */}
      <div className="rounded-2xl border-2 border-[#C9A84C]/50 bg-gradient-to-r from-[#1a1408] via-[#13132a] to-[#1a1408] p-6 sm:p-7 flex items-start gap-4" data-testid="terminos-aceptacion">
        <FileCheck className="h-7 w-7 text-[#E0B835] flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-[11px] text-[#E0B835] font-mono uppercase tracking-[2px] mb-1">13 · Aceptación</p>
          <p className="text-sm sm:text-base text-white font-semibold leading-relaxed">
            Al recibir leads asignados dentro del sistema de Club Viajemos, el agente acepta estos términos como condición para tener derecho a comisión sobre dichos leads.
          </p>
        </div>
      </div>
    </div>
  </section>
);

const ORANGE_VIDEO = "https://customer-assets-jt897jd0.emergentagent.net/job_7d03c1f1-c667-4ac7-8e96-a71fdaaa04a1/artifacts/foa3t6fs_Orange_CreearVocher%20REV%20%281%29.mp4";
const ORANGE_EMBUDO_PDF = "https://customer-assets-jt897jd0.emergentagent.net/job_7d03c1f1-c667-4ac7-8e96-a71fdaaa04a1/artifacts/dnh7ht7z_Embudo%20Viajemos%20Travel%20Assist.pdf";

const OrangeSegurosSection = () => (
  <section className="px-4 py-12 sm:py-16" data-testid="academia-orange-section" id="orange-seguros">
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center gap-4 mb-2">
        <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#F97316]/30 to-[#F97316]/30" />
        <Umbrella className="h-5 w-5 text-[#F97316]" />
        <div className="h-px flex-1 bg-gradient-to-l from-transparent via-[#F97316]/30 to-[#F97316]/30" />
      </div>
      <div className="text-center mb-8">
        <p className="text-[11px] text-[#F97316] font-mono tracking-[3px] uppercase mb-2">Plataforma · Seguros de viaje</p>
        <h2 className="text-3xl sm:text-4xl font-black text-white">Curso <span className="text-[#F97316]">ORANGE</span> · Club Viajemos</h2>
        <p className="text-slate-400 text-sm mt-3 max-w-2xl mx-auto">
          Aprende a manejar <strong className="text-white">ORANGE</strong>, nuestra plataforma de seguros de viaje. Aquí reunimos los tutoriales y guías paso a paso. Empezamos con cómo crear un voucher; en los próximos días sumaremos más material.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-5">
        {/* Video tutorial */}
        <div className="lg:col-span-2 bg-[#0a0a14] border border-[#F97316]/20 rounded-2xl overflow-hidden">
          <div className="flex items-center gap-2 px-5 py-3 border-b border-white/10 bg-[#150d05]">
            <PlayCircle className="h-4 w-4 text-[#F97316]" />
            <p className="text-sm font-bold text-white">Lección 1 · Cómo crear un voucher en ORANGE</p>
          </div>
          <video
            src={ORANGE_VIDEO}
            controls
            preload="metadata"
            playsInline
            data-testid="academia-orange-video"
            className="w-full bg-black aspect-video"
          />
        </div>

        {/* Resumen: qué hacer */}
        <div className="lg:col-span-1 bg-gradient-to-br from-[#1a1005] via-[#13132a] to-[#0a0a14] border-2 border-[#F97316]/40 rounded-2xl p-6 flex flex-col">
          <div className="w-12 h-12 rounded-xl bg-[#F97316]/20 border border-[#F97316]/40 flex items-center justify-center mb-4">
            <FileText className="h-6 w-6 text-[#F97316]" />
          </div>
          <p className="text-[10px] text-[#F97316] font-mono tracking-[2px] uppercase mb-1">Resumen · Qué hacer</p>
          <h3 className="text-lg font-black text-white leading-tight mb-3">Crear un voucher, paso a paso</h3>
          <ol className="space-y-2.5 text-sm text-slate-300 flex-1">
            <li className="flex gap-2.5"><span className="flex-shrink-0 w-6 h-6 rounded-lg bg-[#F97316] text-[#0a0a14] font-black text-xs flex items-center justify-center">1</span> Ingresa a la plataforma <strong className="text-white">ORANGE</strong> con tu usuario de Club Viajemos.</li>
            <li className="flex gap-2.5"><span className="flex-shrink-0 w-6 h-6 rounded-lg bg-[#F97316] text-[#0a0a14] font-black text-xs flex items-center justify-center">2</span> Entra a la opción de <strong className="text-white">crear / emitir voucher</strong>.</li>
            <li className="flex gap-2.5"><span className="flex-shrink-0 w-6 h-6 rounded-lg bg-[#F97316] text-[#0a0a14] font-black text-xs flex items-center justify-center">3</span> Completa los datos del <strong className="text-white">viajero y del viaje</strong> (fechas y destino).</li>
            <li className="flex gap-2.5"><span className="flex-shrink-0 w-6 h-6 rounded-lg bg-[#F97316] text-[#0a0a14] font-black text-xs flex items-center justify-center">4</span> Elige el <strong className="text-white">plan de cobertura</strong> del seguro que corresponda.</li>
            <li className="flex gap-2.5"><span className="flex-shrink-0 w-6 h-6 rounded-lg bg-[#F97316] text-[#0a0a14] font-black text-xs flex items-center justify-center">5</span> Genera el voucher y <strong className="text-white">envíaselo al cliente</strong> como comprobante.</li>
          </ol>
          <div className="mt-4 flex items-start gap-2 bg-[#F97316]/10 border border-[#F97316]/25 rounded-xl p-3">
            <Sparkles className="h-4 w-4 text-[#F97316] flex-shrink-0 mt-0.5" />
            <p className="text-xs text-slate-200 leading-relaxed">Sigue el video para ver cada paso en pantalla. Guía detallada y más lecciones <strong className="text-white">próximamente</strong>.</p>
          </div>
        </div>
      </div>

      {/* Embudo de ventas Travel Assist (PDF) */}
      <div className="mt-6 bg-gradient-to-br from-[#1a1005] via-[#13132a] to-[#0a0a14] border-2 border-[#F97316]/40 rounded-2xl p-6" data-testid="academia-orange-embudo">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-5">
          <div className="w-12 h-12 rounded-xl bg-[#F97316]/20 border border-[#F97316]/40 flex items-center justify-center flex-shrink-0">
            <Target className="h-6 w-6 text-[#F97316]" />
          </div>
          <div className="flex-1">
            <p className="text-[10px] text-[#F97316] font-mono tracking-[2px] uppercase mb-1">Ventas · Seguros de viaje</p>
            <h3 className="text-lg sm:text-xl font-black text-white leading-tight">Embudo de Ventas · Viajemos Travel Assist</h3>
            <p className="text-sm text-slate-400 mt-1">El sistema completo para vender seguros de viaje: atrae, protege y potencia a cada viajero hasta convertirlo en embajador. Incluye flujos, mensajes listos (SMS, WhatsApp, email) y pasos para montarlo en GoHighLevel.</p>
          </div>
          <a
            href={ORANGE_EMBUDO_PDF}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="academia-orange-embudo-pdf"
            className="inline-flex items-center justify-center gap-2 bg-[#F97316] hover:bg-[#ea6a0c] text-[#0a0a14] font-black text-sm px-5 py-3 rounded-xl transition-colors whitespace-nowrap"
          >
            <Download className="h-4 w-4" /> Ver / Descargar embudo (PDF)
          </a>
        </div>
        <div className="grid sm:grid-cols-3 gap-3">
          <div className="rounded-xl border border-[#F97316]/20 bg-[#F97316]/[0.05] p-4">
            <p className="text-[11px] font-black text-[#F97316] mb-1">1 · ATRAER</p>
            <p className="text-xs text-slate-300 leading-relaxed">Captas el contacto y generas confianza con contenido educativo. Nada de vender de una: primero aportas valor.</p>
          </div>
          <div className="rounded-xl border border-[#F97316]/20 bg-[#F97316]/[0.05] p-4">
            <p className="text-[11px] font-black text-[#F97316] mb-1">2 · PROTEGER</p>
            <p className="text-xs text-slate-300 leading-relaxed">Cotizas, das seguimiento y cierras la venta del plan adecuado, con mensajes y tiempos ya definidos.</p>
          </div>
          <div className="rounded-xl border border-[#F97316]/20 bg-[#F97316]/[0.05] p-4">
            <p className="text-[11px] font-black text-[#F97316] mb-1">3 · POTENCIAR</p>
            <p className="text-xs text-slate-300 leading-relaxed">Upgrades, acompañamiento en el viaje, encuesta NPS y referidos para que cada cliente sea embajador.</p>
          </div>
        </div>
      </div>

      {/* Placeholder para más contenido */}
      <div className="mt-6 rounded-2xl border border-dashed border-[#F97316]/30 bg-[#F97316]/[0.04] p-5 flex items-center gap-3" data-testid="academia-orange-proximamente">
        <div className="w-10 h-10 rounded-xl bg-[#F97316]/15 border border-[#F97316]/30 flex items-center justify-center flex-shrink-0">
          <Clock className="h-5 w-5 text-[#F97316]" />
        </div>
        <div>
          <p className="text-sm font-bold text-white">Más lecciones en camino</p>
          <p className="text-xs text-slate-400">Cotizar planes, tipos de cobertura, emisión para grupos, cancelaciones y preguntas frecuentes de ORANGE.</p>
        </div>
      </div>
    </div>
  </section>
);

// Contenido compartido de "Condiciones mínimas de reserva" (puntos 1-5 + tablas).
// plain=false => estilo neón (fondo amarillo). plain=true => estilo normal de la página.
const ReservaCondicionesContenido = ({ plain = false }) => {
  const body = plain ? "text-slate-300" : "text-black";
  const strong = plain ? "text-white font-bold" : "text-black font-extrabold";
  const numBadge = plain
    ? "bg-[#00A9CE] text-white"
    : "bg-black text-[#F5FF00]";
  const numTitle = plain ? "text-white" : "text-black";
  // estilos de tabla / tarjetas
  const tWrap = plain ? "border-white/15" : "border-black";
  const tHead = plain ? "bg-white/5 text-white" : "bg-black text-[#F5FF00]";
  const tCell = plain ? "border-white/10 text-slate-200" : "border-black text-black";
  const tHeadCell = plain ? "border-white/10 text-white" : "border-black text-[#F5FF00]";
  const cardBrd = plain ? "border-white/15 bg-white/[0.03]" : "border-black bg-[#F5FF00]";

  const RowPoint = ({ n, title, children }) => (
    <li className="flex gap-3">
      <span className={`flex-shrink-0 w-7 h-7 rounded-full ${numBadge} font-black text-sm flex items-center justify-center`}>{n}</span>
      <div className="min-w-0">
        <h5 className={`text-[16px] font-extrabold ${numTitle} mb-1`}>{title}</h5>
        <div className={`text-[16px] leading-relaxed ${body}`}>{children}</div>
      </div>
    </li>
  );

  // Tabla A: reparto del markup por nivel de agencia
  const tablaA = [
    { nivel: "Starter", com: "50%", cv: "5%" },
    { nivel: "Profesional", com: "60%", cv: "4%" },
    { nivel: "Travel Empire", com: "80%", cv: "2%" },
  ];
  // Tabla B: reservas de agentes según patrocinador
  const tablaB = [
    { pat: "Starter", cv: "50%", patp: "25%", ag: "25%" },
    { pat: "Profesional", cv: "40%", patp: "35%", ag: "25%" },
    { pat: "Travel Empire", cv: "20%", patp: "55%", ag: "25%" },
  ];

  return (
    <ol className="space-y-5 list-none m-0 p-0">
      <RowPoint n="1" title="Markup mínimo del 10%">
        Toda reserva hecha por un agente o una agencia debe incluir como mínimo un <span className={strong}>10% de markup</span> sobre el precio neto del hotel en la plataforma.
      </RowPoint>

      <RowPoint n="2" title="Cómo se reparte el markup">
        El markup se reparte según el nivel. Las agencias reciben su porcentaje de comisión y Club Viajemos el resto:

        {/* Tabla A — desktop */}
        <div className="hidden sm:block mt-3 overflow-x-auto">
          <table className={`w-full text-[15px] border-collapse border ${tWrap} rounded-lg overflow-hidden`}>
            <thead>
              <tr className={tHead}>
                <th className={`text-left p-2.5 border ${tHeadCell} font-bold`}>Nivel</th>
                <th className={`text-center p-2.5 border ${tHeadCell} font-bold`}>Comisión de la agencia</th>
                <th className={`text-center p-2.5 border ${tHeadCell} font-bold`}>Club Viajemos (del 10% mínimo)</th>
              </tr>
            </thead>
            <tbody>
              {tablaA.map((r) => (
                <tr key={r.nivel}>
                  <td className={`p-2.5 border ${tCell} font-semibold`}>{r.nivel}</td>
                  <td className={`p-2.5 border ${tCell} text-center`}>{r.com}</td>
                  <td className={`p-2.5 border ${tCell} text-center`}>{r.cv}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Tabla A — móvil (tarjetas) */}
        <div className="sm:hidden mt-3 space-y-2">
          {tablaA.map((r) => (
            <div key={r.nivel} className={`rounded-lg border ${cardBrd} p-3`}>
              <div className={`font-extrabold ${numTitle} mb-1`}>{r.nivel}</div>
              <div className={`text-[15px] ${body}`}>Comisión de la agencia: <span className={strong}>{r.com}</span></div>
              <div className={`text-[15px] ${body}`}>Club Viajemos (del 10% mínimo): <span className={strong}>{r.cv}</span></div>
            </div>
          ))}
        </div>

        <p className={`mt-3 text-[16px] leading-relaxed ${body}`}>
          <span className={strong}>Agentes de viajes:</span> el agente gana el <span className={strong}>25% del markup</span>, que le paga su patrocinador de su propia comisión. Por eso, la parte de Club Viajemos en las reservas de un agente es la que corresponde al nivel de su patrocinador:
        </p>

        {/* Tabla B — desktop */}
        <div className="hidden sm:block mt-3 overflow-x-auto">
          <table className={`w-full text-[15px] border-collapse border ${tWrap} rounded-lg overflow-hidden`}>
            <thead>
              <tr className={tHead}>
                <th className={`text-left p-2.5 border ${tHeadCell} font-bold`}>Patrocinador</th>
                <th className={`text-center p-2.5 border ${tHeadCell} font-bold`}>Club Viajemos</th>
                <th className={`text-center p-2.5 border ${tHeadCell} font-bold`}>Patrocinador</th>
                <th className={`text-center p-2.5 border ${tHeadCell} font-bold`}>Agente</th>
              </tr>
            </thead>
            <tbody>
              {tablaB.map((r) => (
                <tr key={r.pat}>
                  <td className={`p-2.5 border ${tCell} font-semibold`}>{r.pat}</td>
                  <td className={`p-2.5 border ${tCell} text-center`}>{r.cv}</td>
                  <td className={`p-2.5 border ${tCell} text-center`}>{r.patp}</td>
                  <td className={`p-2.5 border ${tCell} text-center`}>{r.ag}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Tabla B — móvil (tarjetas) */}
        <div className="sm:hidden mt-3 space-y-2">
          {tablaB.map((r) => (
            <div key={r.pat} className={`rounded-lg border ${cardBrd} p-3`}>
              <div className={`font-extrabold ${numTitle} mb-1`}>Patrocinador: {r.pat}</div>
              <div className={`text-[15px] ${body}`}>Club Viajemos: <span className={strong}>{r.cv}</span></div>
              <div className={`text-[15px] ${body}`}>Patrocinador: <span className={strong}>{r.patp}</span></div>
              <div className={`text-[15px] ${body}`}>Agente: <span className={strong}>{r.ag}</span></div>
            </div>
          ))}
        </div>

        <p className={`mt-3 text-[16px] leading-relaxed ${body}`}>
          <span className={strong}>Ejemplo:</span> hotel con precio neto de $1,000 y markup del 10% ($100). Agencia Starter: gana $50 y Club Viajemos $50. Profesional: $60 y $40. Travel Empire: $80 y $20. Agente con patrocinador Travel Empire: el agente gana $25, el patrocinador $55 y Club Viajemos $20. Si pones un markup mayor al 10%, se reparte con los mismos porcentajes.
        </p>
      </RowPoint>

      <RowPoint n="3" title="Prohibido cobrar comisiones por fuera">
        Está terminantemente prohibido cobrar al cliente comisiones, cargos de servicio o diferencias por fuera de la plataforma.
      </RowPoint>

      <RowPoint n="4" title="Reservas sin comisión o con menos del 10%">
        Se registrará como <span className={strong}>deuda pendiente de pago</span>, a cargo del agente o la agencia que generó la reserva, la parte de Club Viajemos calculada sobre el 10% mínimo: <span className={strong}>5% del precio neto</span> del hotel (Starter), <span className={strong}>4%</span> (Profesional) o <span className={strong}>2%</span> (Travel Empire). En reservas de agentes se aplica el porcentaje del nivel de su patrocinador. Se descuenta lo que ya se haya pagado.
        <div className={`mt-3 rounded-lg border p-3 ${plain ? "border-[#4ADE80]/40 bg-[#4ADE80]/10" : "border-black bg-black/10"}`}>
          <span className={strong}>Única salvedad:</span> no se cobra comisión cuando la reserva sale <span className={strong}>a nombre de la propia agencia o del propio agente</span> (uso personal). En ese caso, el agente o la agencia debe ser el <span className={strong}>dueño/titular de la reserva</span>.
        </div>
      </RowPoint>

      <RowPoint n="5" title="Derecho de cancelación">
        Club Viajemos se reserva el derecho de cancelar, previo aviso, cualquier reserva que no cumpla estas condiciones. Las penalidades o cargos que aplique el hotel serán asumidos por quien generó la reserva.
      </RowPoint>
    </ol>
  );
};


const AcademiaPage = () => {
  const [unlocked, setUnlocked] = useState(() => sessionStorage.getItem("academia_unlocked") === "1");
  const [query, setQuery] = useState("");
  const [showSug, setShowSug] = useState(false);
  const [open, setOpen] = useState({});
  const [recordings, setRecordings] = useState([]);
  const [reservaAceptada, setReservaAceptada] = useState(() => localStorage.getItem("ratehawk_reserva_aceptada") === "1");
  const [reservaFecha, setReservaFecha] = useState(() => localStorage.getItem("ratehawk_reserva_fecha") || "");
  const aceptarReserva = (checked) => {
    setReservaAceptada(checked);
    if (checked) {
      const now = new Date().toISOString();
      let cid = localStorage.getItem("cv_client_id");
      if (!cid) { cid = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now())); localStorage.setItem("cv_client_id", cid); }
      localStorage.setItem("ratehawk_reserva_aceptada", "1");
      localStorage.setItem("ratehawk_reserva_fecha", now);
      setReservaFecha(now);
      fetch(`${API_URL}/api/academia/aceptacion-reserva`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ client_id: cid, fecha: now, pagina: "ratehawk" }),
      }).catch(() => {});
    } else {
      localStorage.removeItem("ratehawk_reserva_aceptada");
      localStorage.removeItem("ratehawk_reserva_fecha");
      setReservaFecha("");
    }
  };
  const fmtAceptHora = (iso) => { if (!iso) return ""; const d = new Date(iso); return isNaN(d) ? "" : d.toLocaleString("es", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); };
  const toggle = (k) => setOpen((o) => ({ ...o, [k]: !o[k] }));

  // Cargar videos de la Academia (tutorials con location=academia) una vez desbloqueada
  useEffect(() => {
    if (!unlocked) return;
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/tutorials`, { cache: "no-store" });
        if (res.ok) {
          const data = await res.json();
          if (alive && Array.isArray(data)) {
            const acad = data
              .filter((t) => (t.location || "home") === "academia")
              .sort((a, b) => (b.recorded_date || "").localeCompare(a.recorded_date || ""));
            setRecordings(acad);
          }
        }
      } catch (e) { console.error("Recordings fetch failed:", e); }
    })();
    return () => { alive = false; };
  }, [unlocked]);

  const q = norm(query.trim());
  const searching = q.length > 0;
  const filteredCursos = CURSOS.filter((c) => matchCurso(c, q)).sort((a, b) => cursoScore(b, q) - cursoScore(a, q));
  const filteredProspectar = CURSOS_PROSPECTAR.filter((c) => matchCurso(c, q)).sort((a, b) => cursoScore(b, q) - cursoScore(a, q));

  // Grabaciones que coinciden con la búsqueda (título, descripción, presentador, curso)
  const matchedRecordings = searching
    ? recordings.filter((r) => {
        const hay = norm(`${r.title} ${r.description || ""} ${r.presenter || ""} ${r.secreto || ""}`);
        return q.split(/\s+/).every((tok) => hay.includes(tok));
      })
    : recordings;

  const totalResults = filteredCursos.length + filteredProspectar.length + (searching ? matchedRecordings.length : 0);

  // Sugerencias del autocompletar: cursos + temas + grabaciones por título
  const recordingSuggestions = query.trim().length >= 2
    ? recordings
        .filter((r) => norm(r.title).includes(norm(query.trim())))
        .slice(0, 4)
        .map((r) => ({ type: "grabacion", label: r.title, sub: r.recorded_date, href: "#grabaciones", accent: "#C9A84C" }))
    : [];
  const suggestions = [...recordingSuggestions, ...getSuggestions(query)].slice(0, 8);


  if (!unlocked) {
    return <AcademiaGate onUnlock={() => setUnlocked(true)} />;
  }

  return (
    <div className="min-h-screen bg-[#0a0a14]" style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }} data-testid="academia-page">
      {/* TOP STRIP */}
      <div className="bg-gradient-to-r from-[#C9A84C] via-[#E0B835] to-[#C9A84C] text-[#0a0a14] text-center py-2 text-xs sm:text-sm font-black tracking-wider sticky top-0 z-40">
        <GraduationCap className="inline h-3.5 w-3.5 mr-1.5 mb-0.5" />
        UNIVERSIDAD TRAVEL EMPIRE · 5 CURSOS PROFESIONALES · CERTIFICACIÓN INCLUIDA
      </div>

      {/* HERO */}
      <section className="relative px-4 pt-16 pb-12 sm:pt-20 sm:pb-16">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute inset-0 bg-gradient-to-br from-[#0D1B2A] via-[#13132a] to-[#0a0a14]" />
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#C9A84C]/15 rounded-full blur-[160px]" />
        </div>

        <div className="relative max-w-5xl mx-auto text-center">
          <p className="inline-block bg-[#C9A84C]/15 text-[#C9A84C] text-[11px] sm:text-xs uppercase tracking-[3px] px-4 py-1.5 rounded-full font-mono mb-6 border border-[#C9A84C]/30">
            Formación oficial · Carlos Miami Fernandez
          </p>

          <h1 className="text-4xl sm:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight mb-5">
            La Universidad<br />
            <span className="text-[#C9A84C]">Travel Empire</span>
          </h1>

          <p className="text-base sm:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed mb-3">
            5 cursos profesionales — uno por cada Secreto del sistema — con guiones reales, secuencias validadas y casos cerrados por los agentes top.
          </p>
          <p className="text-sm sm:text-base text-slate-400 max-w-2xl mx-auto mb-8">
            Todo el conocimiento que necesitas para facturar tu primer mes de $3,000–$25,000 USD desde tu casa.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-4 gap-4 sm:gap-8 max-w-3xl mx-auto py-6 border-y border-white/10">
            <Stat value="11" label="Cursos" />
            <Stat value="2" label="Categorías" />
            <Stat value="55+" label="Módulos" />
            <Stat value="100%" label="Online" />
          </div>

          {/* BUSCADOR */}
          <div className="max-w-2xl mx-auto mt-8">
            <div className="relative">
              <div className="relative">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-[#C9A84C] pointer-events-none z-10" />
                <input
                  type="text"
                  value={query}
                  onChange={(e) => { setQuery(e.target.value); setShowSug(true); }}
                  onFocus={() => setShowSug(true)}
                  onBlur={() => setTimeout(() => setShowSug(false), 180)}
                  autoComplete="off"
                  placeholder="Busca curso o tema: objeciones, calificaciones, WhatsApp, ChatGPT, cierre…"
                  data-testid="academia-search-input"
                  className="w-full bg-[#0f0f1e]/80 border border-[#C9A84C]/30 focus:border-[#C9A84C] text-white rounded-2xl pl-12 pr-11 py-4 outline-none transition-colors placeholder:text-white/40 shadow-lg backdrop-blur relative"
                />
                {query && (
                  <button
                    type="button"
                    onClick={() => { setQuery(""); setShowSug(false); }}
                    data-testid="academia-search-clear"
                    aria-label="Limpiar búsqueda"
                    className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white/70 hover:text-white transition-colors z-10"
                  >
                    <X className="h-4 w-4" />
                  </button>
                )}
              </div>

              {/* DROPDOWN DE SUGERENCIAS */}
              {showSug && suggestions.length > 0 && (
                <div
                  className="absolute z-50 left-0 right-0 mt-2 bg-[#0f0f1e]/95 border border-[#C9A84C]/30 rounded-2xl shadow-[0_24px_60px_rgba(0,0,0,0.55)] overflow-hidden text-left backdrop-blur-xl"
                  data-testid="academia-suggestions"
                >
                  <p className="px-4 pt-3 pb-2 text-[10px] font-mono uppercase tracking-[2px] text-slate-500">
                    Elige un tema o curso para abrirlo
                  </p>
                  <div className="max-h-[340px] overflow-y-auto">
                    {suggestions.map((s, i) => (
                      <a
                        key={s.type + s.label + i}
                        href={s.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => setShowSug(false)}
                        data-testid={`academia-suggestion-${i}`}
                        className="flex items-center gap-3 px-4 py-2.5 hover:bg-white/[0.06] transition-colors border-t border-white/5"
                      >
                        <span
                          className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 border"
                          style={{ backgroundColor: `${s.accent}1F`, borderColor: `${s.accent}66` }}
                        >
                          {s.type === "curso"
                            ? <BookOpen className="h-4 w-4" style={{ color: s.accent }} />
                            : s.type === "grabacion"
                            ? <Video className="h-4 w-4" style={{ color: s.accent }} />
                            : <Search className="h-4 w-4" style={{ color: s.accent }} />}
                        </span>
                        <span className="min-w-0 flex-1">
                          <span className="block text-sm font-semibold text-white truncate">{s.label}</span>
                          <span className="block text-[11px] text-slate-400 truncate">
                            {s.type === "curso" ? "Curso completo" : s.type === "grabacion" ? `Grabación · ${s.sub}` : `Tema · ${s.sub}`}
                          </span>
                        </span>
                        <ArrowRight className="h-4 w-4 text-slate-500 flex-shrink-0" />
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {searching && !showSug && (
              <p className="text-xs text-slate-400 mt-3" data-testid="academia-search-count">
                {totalResults > 0
                  ? `${totalResults} ${totalResults === 1 ? "curso encontrado" : "cursos encontrados"} para "${query.trim()}"`
                  : `Sin resultados para "${query.trim()}"`}
              </p>
            )}
          </div>
        </div>
      </section>

      {/* GRABACIONES EN VIVO / ZOOM */}
      <ZoomRecordingsSection
        recordings={matchedRecordings}
        cursoMeta={SECRETO_META}
        searching={searching}
        query={query}
      />

      {/* GRID DE CURSOS */}
      {!(searching && filteredCursos.length === 0) && (
      <section className="px-4 py-12 sm:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-4 mb-2">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#C9A84C]/30 to-[#C9A84C]/30" />
            <Award className="h-5 w-5 text-[#C9A84C]" />
            <div className="h-px flex-1 bg-gradient-to-l from-transparent via-[#C9A84C]/30 to-[#C9A84C]/30" />
          </div>
          <div className="text-center mb-10">
            <p className="text-[11px] text-[#C9A84C] font-mono tracking-[3px] uppercase mb-2">Categoría · Los 5 Secretos</p>
            <h2 className="text-3xl sm:text-4xl font-black text-white">Uno por cada producto del sistema</h2>
            <p className="text-slate-400 text-sm mt-3 max-w-xl mx-auto">
              Cada curso te entrena en un producto específico. Avanza en orden o salta al que más te interese.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filteredCursos.map((c) => (
              <CursoCard key={c.secreto} curso={c} query={query} />
            ))}
          </div>
        </div>
      </section>
      )}

      {/* SECCIÓN: PROSPECTAR */}
      {!(searching && filteredProspectar.length === 0) && (
      <section className="px-4 pb-12 sm:pb-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-4 mb-2">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#45A0EE]/30 to-[#45A0EE]/30" />
            <Target className="h-5 w-5 text-[#45A0EE]" />
            <div className="h-px flex-1 bg-gradient-to-l from-transparent via-[#45A0EE]/30 to-[#45A0EE]/30" />
          </div>
          <div className="text-center mb-10">
            <p className="text-[11px] text-[#45A0EE] font-mono tracking-[3px] uppercase mb-2">Categoría · Prospectar</p>
            <h2 className="text-3xl sm:text-4xl font-black text-white">Cómo conseguir más clientes</h2>
            <p className="text-slate-400 text-sm mt-3 max-w-xl mx-auto">
              Cursos prácticos para llenar tu agenda de prospectos calificados — sin gastar en publicidad innecesaria.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filteredProspectar.map((c) => (
              <CursoCard key={c.id} curso={c} query={query} />
            ))}
          </div>

          {/* Hint: más cursos por venir */}
          {!searching && (
          <div className="mt-6 text-center">
            <p className="text-xs text-slate-500 italic">
              <Sparkles className="inline h-3 w-3 text-slate-600 mr-1 mb-0.5" />
              Más cursos de prospección en camino: presencial, networking, eventos y referidos en frío.
            </p>
          </div>
          )}
        </div>
      </section>
      )}

      {/* Sin resultados */}
      {searching && totalResults === 0 && (
        <section className="px-4 py-16" data-testid="academia-no-results">
          <div className="max-w-md mx-auto text-center">
            <div className="mx-auto mb-5 w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center">
              <Search className="h-7 w-7 text-slate-500" />
            </div>
            <h3 className="text-xl font-black text-white mb-2">No encontramos cursos para "{query.trim()}"</h3>
            <p className="text-sm text-slate-400 mb-6">Prueba con otra palabra como <span className="text-[#C9A84C]">certificados</span>, <span className="text-[#C9A84C]">visas</span>, <span className="text-[#C9A84C]">cierre</span> o <span className="text-[#C9A84C]">IA</span>.</p>
            <button
              type="button"
              onClick={() => setQuery("")}
              className="inline-flex items-center gap-2 bg-[#C9A84C] text-[#0a0a14] font-bold px-5 py-2.5 rounded-xl hover:opacity-90 transition-opacity"
            >
              <X className="h-4 w-4" /> Limpiar búsqueda
            </button>
          </div>
        </section>
      )}

      {/* Cursos de cada Secreto (igual que en /comunidad) */}
      {!searching && (<>
      <section className="px-4 py-10" data-testid="academia-cursos-section">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-6">
            <div className="inline-flex items-center gap-2 bg-[#C9A84C]/15 border border-[#C9A84C]/40 text-[#C9A84C] px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-3">
              <GraduationCap className="h-4 w-4" /> Universidad Travel Empire
            </div>
            <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-2">
              Cursos de cada <span className="text-[#C9A84C]">Secreto</span>
            </h2>
            <p className="text-slate-300 text-sm md:text-base max-w-2xl mx-auto">
              Un curso profesional por cada Secreto del sistema — guiones reales, objeciones con cierre y certificación.
            </p>
          </div>

          {/* CURSO DESTACADO · Centro de Comando de Leads (GoHighLevel) */}
          <a
            href="/curso-gohighlevel-clubviajemos.html"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="academia-curso-destacado-ghl"
            className="group relative block mb-5 overflow-hidden rounded-2xl p-[2px] bg-gradient-to-r from-[#C9A84C] via-[#F5D77A] to-[#C9A84C] shadow-[0_12px_50px_rgba(201,168,76,0.35)] hover:shadow-[0_16px_60px_rgba(201,168,76,0.5)] transition-all hover:scale-[1.005]"
          >
            <div className="relative rounded-2xl bg-gradient-to-br from-[#0D1B2A] via-[#15233a] to-[#0D1B2A] p-6 sm:p-7">
              <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 bg-[#C9A84C] text-[#0D1B2A] text-[10px] font-black uppercase tracking-[0.15em] px-3 py-1 rounded-full">
                <Sparkles className="h-3 w-3" /> Curso destacado
              </span>
              <div className="flex items-start gap-4 sm:gap-5">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-[#C9A84C]/20 border border-[#C9A84C]/50 flex items-center justify-center flex-shrink-0">
                  <Rocket className="h-7 w-7 sm:h-8 sm:w-8 text-[#C9A84C]" />
                </div>
                <div className="flex-1 min-w-0 pr-16 sm:pr-0">
                  <p className="text-[10px] text-[#C9A84C] font-mono tracking-[2px] uppercase mb-1.5">Travel Empire · GHL · Imperdible</p>
                  <h3 className="text-xl sm:text-2xl font-black text-white leading-tight mb-1.5">
                    Centro de Comando de Leads <span className="text-[#C9A84C]">(GoHighLevel)</span>
                  </h3>
                  <p className="text-sm text-slate-300 leading-snug mb-3">
                    Tu centro de control para atraer, dar seguimiento y cerrar: entrar, la app, contactos, mensajes (SMS/WhatsApp/email), calendario, Zoom, Margarita IA y el link del webinar — paso a paso, desde cero.
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-[#C9A84C] font-bold text-sm uppercase tracking-wider group-hover:gap-2.5 transition-all">
                    Abrir curso <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </div>
            </div>
          </a>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { href: "/cursoelpaquetedelmillon", badge: "SECRETO #1 · EL PAQUETE DEL MILLÓN", title: "Certificados de Viaje", sub: "Pitch perfecto · método de los 3 círculos · 8 objeciones con cierre · plan 90 días" },
              { href: "/cursovisaconexito", badge: "SECRETO #2 · VISA CON ÉXITO", title: "Asesorías Migratorias", sub: "7 preguntas de descubrimiento · 5 ventajas · 10 objeciones con cierre · referidos" },
              { href: "/cursoacademiab2b", badge: "SECRETO #3 · ACADEMIA B2B · CERTIFICACIÓN", title: "Plataforma B2B RateHawk", sub: "RateHawk · sub-agencias · cotización profesional · examen final + sello" },
              { href: "/cursoclubvacacional", badge: "SECRETO #4 · 12 LECCIONES", title: "Club Vacacional", sub: "Proceso de 15 pasos · venta online y presencial · 8 objeciones · certificado final" },
              { href: "/cursoreferidos", badge: "SECRETO #5 · EL PODER DE REFERIR", title: "Embajador Digital", sub: "8 módulos · URL Hotmart · 2 salas semanales · regla del 25% · calculadora de ganancias" },
              { href: "/proyecto-ghl-leads-dinero.html", badge: "PROYECTO TRAVEL EMPIRE", title: "El Motor y la Gasolina", sub: "El proyecto completo: cómo GHL genera leads que se convierten en dinero" },
            ].map((curso) => (
              <a
                key={curso.href}
                href={curso.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`academia-curso-${curso.href.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
                className="group block bg-gradient-to-br from-[#0D1B2A] via-[#1B263B] to-[#0D1B2A] border-2 border-[#C9A84C]/40 hover:border-[#C9A84C] rounded-xl p-5 transition-all hover:shadow-[0_10px_40px_rgba(201,168,76,0.25)] hover:scale-[1.01]"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#C9A84C]/20 border border-[#C9A84C]/40 flex items-center justify-center flex-shrink-0">
                    <GraduationCap className="h-6 w-6 text-[#C9A84C]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[10px] text-[#C9A84C] font-mono tracking-[2px] uppercase mb-1">{curso.badge}</p>
                    <h4 className="text-base sm:text-lg font-bold text-white leading-tight mb-1">{curso.title}</h4>
                    <p className="text-xs sm:text-sm text-slate-300 leading-snug">{curso.sub}</p>
                  </div>
                  <div className="flex items-center gap-1 text-[#C9A84C] font-bold text-xs uppercase tracking-wider flex-shrink-0 group-hover:gap-2 transition-all">
                    <span className="hidden sm:inline">Abrir curso</span>
                    <ArrowRight className="h-4 w-4" />
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* Manual completo + Bonus $500 */}
          <a
            href="/manual27"
            data-testid="academia-cta-manual27"
            className="group mt-6 flex items-center justify-between gap-4 bg-gradient-to-r from-[#1a1428] via-[#2a2018] to-[#1a1428] hover:from-[#2a2018] hover:to-[#1a1428] border border-amber-400/40 hover:border-amber-400/70 rounded-xl px-5 py-4 transition-all shadow-lg hover:shadow-[0_10px_40px_rgba(212,175,55,0.2)]"
          >
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-11 h-11 rounded-lg bg-amber-400/20 border border-amber-400/40 flex items-center justify-center flex-shrink-0">
                <Gift className="h-5 w-5 text-amber-300" />
              </div>
              <div className="min-w-0">
                <p className="text-[10px] text-amber-300 font-mono uppercase tracking-[2px] mb-0.5">MANUAL COMPLETO + BONUS $500 USD</p>
                <p className="text-white font-bold text-sm sm:text-base truncate">Manual de 252 páginas + Protocolo 2026 <span className="text-slate-400 font-normal">— y $500 USD de regalo</span></p>
                <p className="text-slate-400 text-xs truncate hidden sm:block">Entregado en tu reunión virtual con un agente exitoso</p>
              </div>
            </div>
            <span className="flex items-center gap-1 text-amber-300 text-xs font-bold uppercase tracking-wider flex-shrink-0 group-hover:gap-2 transition-all">
              Ver <ArrowRight className="h-4 w-4" />
            </span>
          </a>
        </div>
      </section>

      {/* SECCIÓN INDEPENDIENTE: RATEHAWK */}
      <section className="px-4 pt-6 pb-2">
        <div className="max-w-6xl mx-auto">
          <AccordionCard
            Icon={Hotel}
            accent="#00A9CE"
            testid="academia-card-ratehawk"
            badge="Plataforma B2B · Hoteles"
            title="Todo sobre RateHawk"
            desc="Resumen 2026, sistema de sub-agencias, comisiones por plan y guía paso a paso."
            open={!!open.ratehawk}
            onToggle={() => toggle("ratehawk")}
          />
        </div>
      </section>
      {open.ratehawk && (
      <section className="px-4 py-12 sm:py-16" data-testid="academia-ratehawk-section" id="ratehawk">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-4 mb-2">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#00A9CE]/30 to-[#00A9CE]/30" />
            <Hotel className="h-5 w-5 text-[#00A9CE]" />
            <div className="h-px flex-1 bg-gradient-to-l from-transparent via-[#00A9CE]/30 to-[#00A9CE]/30" />
          </div>
          <div className="text-center mb-8">
            <p className="text-[11px] text-[#00A9CE] font-mono tracking-[3px] uppercase mb-2">Plataforma B2B · Hoteles</p>
            <h2 className="text-3xl sm:text-4xl font-black text-white">Todo sobre <span className="text-[#00A9CE]">RateHawk</span></h2>
            <p className="text-slate-400 text-sm mt-3 max-w-2xl mx-auto">
              Aquí reunimos toda la información de RateHawk, nuestra plataforma de reservas de hoteles con las mejores tarifas de la industria. Empieza con el resumen oficial 2026 y pronto sumaremos más guías, tutoriales y material de apoyo.
            </p>
          </div>

          {/* BLOQUE DESTACADO · CONDICIONES MÍNIMAS DE RESERVA */}
          <style>{`
            @keyframes cvNeonPulse {
              0%,100% { box-shadow: 0 0 12px rgba(245,255,0,0.9); }
              50% { box-shadow: 0 0 36px rgba(245,255,0,0.95); }
            }
            .cv-neon-reserva { animation: cvNeonPulse 1.6s ease-in-out infinite; }
            @media (prefers-reduced-motion: reduce) { .cv-neon-reserva { animation: none; } }
          `}</style>
          <div
            data-testid="ratehawk-condiciones-neon"
            className="cv-neon-reserva mb-10 rounded-2xl bg-[#F5FF00] text-black border-[3px] border-black p-6 sm:p-8"
          >
            <h3 className="text-xl sm:text-2xl font-black uppercase tracking-tight flex items-start gap-2 mb-1">
              <span aria-hidden="true">⚠️</span>
              <span>Condiciones mínimas de reserva (obligatorias)</span>
            </h3>
            <p className="text-[15px] font-bold mb-3">Vigentes desde el 1 de enero de 2026.</p>
            <p className="text-[16px] leading-relaxed mb-5">
              En Club Viajemos somos socios en el mismo negocio: tú te llevas la mayor parte de la ganancia y Club Viajemos una parte menor. Para que esta sociedad funcione, <strong className="font-extrabold">toda reserva debe generar comisión</strong>.
            </p>
            <ReservaCondicionesContenido plain={false} />
            <p className="mt-5 text-[16px] font-extrabold border-t-2 border-black pt-4">
              Al realizar una reserva aceptas estas condiciones.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-5">
            {/* Tarjeta destacada del documento */}
            <div className="lg:col-span-1 bg-gradient-to-br from-[#04283a] via-[#0a1826] to-[#04283a] border-2 border-[#00A9CE]/40 rounded-2xl p-6 flex flex-col">
              <div className="w-12 h-12 rounded-xl bg-[#00A9CE]/20 border border-[#00A9CE]/40 flex items-center justify-center mb-4">
                <FileText className="h-6 w-6 text-[#00A9CE]" />
              </div>
              <p className="text-[10px] text-[#00A9CE] font-mono tracking-[2px] uppercase mb-1">Documento oficial</p>
              <h3 className="text-lg font-bold text-white leading-tight mb-2">RateHawk — Resumen 2026 (ES)</h3>
              <p className="text-sm text-slate-300 leading-snug mb-5 flex-1">
                Guía resumida de la plataforma: cómo funciona, ventajas, tarifas y todo lo que necesitas para empezar a reservar hoteles con RateHawk.
              </p>
              <div className="flex flex-col gap-2">
                {/* Casilla de aceptación obligatoria */}
                <label className="flex items-start gap-2.5 bg-[#F5FF00]/10 border border-[#F5FF00]/40 rounded-xl p-3 cursor-pointer" data-testid="ratehawk-aceptacion-label">
                  <input
                    type="checkbox"
                    checked={reservaAceptada}
                    onChange={(e) => aceptarReserva(e.target.checked)}
                    data-testid="ratehawk-aceptacion-checkbox"
                    className="mt-0.5 h-5 w-5 flex-shrink-0 accent-[#00A9CE] cursor-pointer"
                  />
                  <span className="text-[13px] text-slate-200 leading-snug">
                    He leído y acepto las{" "}
                    <a href="#ratehawk-terminos" className="text-[#F5FF00] font-semibold underline underline-offset-2" data-testid="ratehawk-aceptacion-link">
                      Condiciones mínimas de reserva
                    </a>{" "}
                    (markup mínimo del 10%).
                  </span>
                </label>
                {reservaAceptada && reservaFecha && (
                  <p className="text-[11px] text-[#4ADE80] flex items-center gap-1.5" data-testid="ratehawk-aceptacion-fecha">
                    <CheckCircle2 className="h-3.5 w-3.5" /> Aceptado el {fmtAceptHora(reservaFecha)}
                  </p>
                )}
                <a
                  href={reservaAceptada ? "/docs/ratehawk-resumen-2026.pdf" : undefined}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-disabled={!reservaAceptada}
                  onClick={(e) => { if (!reservaAceptada) e.preventDefault(); }}
                  data-testid="academia-ratehawk-open"
                  className={`inline-flex items-center justify-center gap-2 font-bold py-2.5 rounded-xl text-sm transition-opacity ${reservaAceptada ? "bg-gradient-to-r from-[#00A9CE] to-[#0090C4] text-white hover:opacity-90" : "bg-white/10 text-slate-500 cursor-not-allowed pointer-events-none opacity-60"}`}
                >
                  <BookOpen className="h-4 w-4" /> Ir a reservar en RateHawk
                </a>
                <a
                  href="/docs/ratehawk-resumen-2026.pdf"
                  download
                  data-testid="academia-ratehawk-download"
                  className="inline-flex items-center justify-center gap-2 bg-white/5 border border-white/15 text-white font-semibold py-2.5 rounded-xl hover:bg-white/10 transition-colors text-sm"
                >
                  <Download className="h-4 w-4" /> Descargar PDF
                </a>
              </div>
            </div>

            {/* Visor embebido del PDF */}
            <div className="lg:col-span-2 bg-[#0a0a14] border border-white/10 rounded-2xl overflow-hidden min-h-[420px]">
              <iframe
                src="/docs/ratehawk-resumen-2026.pdf#view=FitH"
                title="RateHawk Resumen 2026"
                data-testid="academia-ratehawk-iframe"
                className="w-full h-[420px] sm:h-[560px]"
              />
            </div>
          </div>

          {/* NUEVO: SISTEMA DE SUB-AGENCIAS */}
          <div className="mt-10 bg-gradient-to-br from-[#04283a] via-[#071624] to-[#04283a] border-2 border-[#00A9CE]/30 rounded-2xl p-6 sm:p-8" data-testid="academia-ratehawk-subagencias">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-11 h-11 rounded-xl bg-[#00A9CE]/20 border border-[#00A9CE]/40 flex items-center justify-center flex-shrink-0">
                <Users2 className="h-5 w-5 text-[#00A9CE]" />
              </div>
              <div>
                <p className="text-[10px] text-[#00A9CE] font-mono tracking-[2px] uppercase">Novedad · Agencia de viajes</p>
                <h3 className="text-xl sm:text-2xl font-black text-white leading-tight">Sistema de sub-agencias en RateHawk</h3>
              </div>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed mb-6">
              Ahora las agencias de Club Viajemos pueden crecer abriendo sus propias sub-agencias dentro de RateHawk. Así funciona, explicado simple para que cualquier agente lo entienda:
            </p>

            <div className="space-y-4">
              {/* 1 */}
              <div className="flex gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">1</span>
                <div>
                  <h4 className="text-sm font-bold text-white mb-1">Registro de sub-agencias</h4>
                  <p className="text-sm text-slate-300 leading-relaxed">
                    Las nuevas agencias de Club Viajemos cuentan con un sistema de registro donde pueden agregar sus propias sub-agencias. Tú abres las sub-agencias que quieras y ellas trabajan por debajo de tu agencia principal.
                  </p>
                </div>
              </div>
              {/* 2 */}
              <div className="flex gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">2</span>
                <div>
                  <h4 className="text-sm font-bold text-white mb-1">Cómo ganan las sub-agencias</h4>
                  <p className="text-sm text-slate-300 leading-relaxed">
                    Cada sub-agencia puede comprar con <strong className="text-white">valor de comisión cero (precio neto)</strong>, o agregarle valor (<strong className="text-white">mark up</strong>) y vender a un precio mayor al que tiene, quedándose con esa diferencia como ganancia.
                  </p>
                </div>
              </div>
              {/* 3 */}
              <div className="flex gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">3</span>
                <div>
                  <h4 className="text-sm font-bold text-white mb-1">Comisión / mark up oculto por defecto</h4>
                  <p className="text-sm text-slate-300 leading-relaxed">
                    Cada vez que se abre una sub-agencia, se le agrega por defecto una comisión o mark up <strong className="text-white">"escondido"</strong> que queda incluido automáticamente en el valor de los hoteles. Esto aplica siempre: cada vez que un sub-agente compra o vende algo, ese diferencial ya viene incluido en el precio, sin que el sub-agente tenga que configurar nada.
                  </p>
                </div>
              </div>
              {/* 4 */}
              <div className="flex gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">4</span>
                <div>
                  <h4 className="text-sm font-bold text-white mb-1">Reparto del diferencial según el plan</h4>
                  <p className="text-sm text-slate-300 leading-relaxed">
                    Ese diferencial (la comisión / mark up oculto) se reparte entre Club Viajemos y el agente según el plan en el que esté registrado:
                  </p>
                  <ul className="mt-2 space-y-1 text-sm text-slate-300">
                    <li>• <strong className="text-white">Plan Starter:</strong> 50 / 50</li>
                    <li>• <strong className="text-white">Plan Duo:</strong> 55 / 45</li>
                    <li>• <strong className="text-white">Plan Profesional:</strong> 60 / 40</li>
                    <li>• <strong className="text-white">Plan Travel Empire:</strong> 80 / 20</li>
                  </ul>
                </div>
              </div>
              {/* 5 */}
              <div className="flex gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">5</span>
                <div>
                  <h4 className="text-sm font-bold text-white mb-1">Costo de registro de cada sub-agencia</h4>
                  <p className="text-sm text-slate-300 leading-relaxed">
                    Depende del plan del agente principal:
                  </p>
                  <ul className="mt-2 space-y-1 text-sm text-slate-300">
                    <li>• <strong className="text-white">Starter:</strong> $79 por sub-agencia</li>
                    <li>• <strong className="text-white">Duo:</strong> $59 por sub-agencia</li>
                    <li>• <strong className="text-white">Profesional:</strong> $39 por sub-agencia</li>
                    <li>• <strong className="text-white">Travel Empire:</strong> gratis e ilimitado</li>
                  </ul>
                </div>
              </div>
              {/* 6 */}
              <div className="flex gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">6</span>
                <div>
                  <h4 className="text-sm font-bold text-white mb-1">Pagos de comisiones</h4>
                  <p className="text-sm text-slate-300 leading-relaxed">
                    Los pagos de las reservas se realizan al <strong className="text-white">final del mes siguiente</strong> a la fecha de check-out de cada reserva.
                  </p>
                </div>
              </div>
            </div>

            {/* 7 · TABLA COMPARATIVA */}
            <div className="mt-7">
              <h4 className="text-sm font-bold text-white mb-3 flex items-center gap-2">
                <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">7</span>
                Tabla comparativa de planes
              </h4>
              <div className="overflow-x-auto rounded-xl border border-[#00A9CE]/25">
                <table className="w-full text-sm border-collapse" data-testid="academia-subagencias-tabla">
                  <thead>
                    <tr className="bg-[#00A9CE]/15 text-white">
                      <th className="text-left font-bold px-4 py-3 border-b border-[#00A9CE]/25">Plan</th>
                      <th className="text-left font-bold px-4 py-3 border-b border-[#00A9CE]/25">Reparto (Club Viajemos / Agente)</th>
                      <th className="text-left font-bold px-4 py-3 border-b border-[#00A9CE]/25">Costo por sub-agencia</th>
                    </tr>
                  </thead>
                  <tbody className="text-slate-200">
                    <tr className="odd:bg-white/[0.02]">
                      <td className="px-4 py-3 border-b border-white/5 font-semibold text-white">Starter</td>
                      <td className="px-4 py-3 border-b border-white/5">50 / 50</td>
                      <td className="px-4 py-3 border-b border-white/5">$79</td>
                    </tr>
                    <tr className="odd:bg-white/[0.02]">
                      <td className="px-4 py-3 border-b border-white/5 font-semibold text-white">Duo</td>
                      <td className="px-4 py-3 border-b border-white/5">55 / 45</td>
                      <td className="px-4 py-3 border-b border-white/5">$59</td>
                    </tr>
                    <tr className="odd:bg-white/[0.02]">
                      <td className="px-4 py-3 border-b border-white/5 font-semibold text-white">Profesional</td>
                      <td className="px-4 py-3 border-b border-white/5">60 / 40</td>
                      <td className="px-4 py-3 border-b border-white/5">$39</td>
                    </tr>
                    <tr className="bg-[#C9A84C]/10">
                      <td className="px-4 py-3 font-black text-[#E0B835]">Travel Empire</td>
                      <td className="px-4 py-3 text-white">80 / 20</td>
                      <td className="px-4 py-3 text-white font-semibold">Gratis e ilimitado</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* GUÍA PASO A PASO */}
            <div className="mt-8 pt-7 border-t border-[#00A9CE]/20" data-testid="academia-subagencias-guia">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl bg-[#00A9CE]/20 border border-[#00A9CE]/40 flex items-center justify-center flex-shrink-0">
                  <Rocket className="h-5 w-5 text-[#00A9CE]" />
                </div>
                <div>
                  <p className="text-[10px] text-[#00A9CE] font-mono tracking-[2px] uppercase">Guía práctica</p>
                  <h4 className="text-lg font-black text-white leading-tight">Cómo abrir y operar tu sub-agencia (paso a paso)</h4>
                </div>
              </div>

              <div className="space-y-3">
                <div className="flex gap-3 bg-white/[0.02] border border-white/5 rounded-xl p-3.5">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">1</span>
                  <div>
                    <h5 className="text-sm font-bold text-white mb-0.5">Entra a tu cuenta de RateHawk</h5>
                    <p className="text-sm text-slate-300 leading-relaxed">Ingresa con tu usuario de agencia principal de Club Viajemos. Es desde esta cuenta que vas a crear y administrar tus sub-agencias.</p>
                  </div>
                </div>
                <div className="flex gap-3 bg-white/[0.02] border border-white/5 rounded-xl p-3.5">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">2</span>
                  <div>
                    <h5 className="text-sm font-bold text-white mb-0.5">Abre la sección de sub-agencias</h5>
                    <p className="text-sm text-slate-300 leading-relaxed">Dentro de tu panel busca la opción de <strong className="text-white">registro de sub-agencias</strong> y elige "crear nueva sub-agencia".</p>
                  </div>
                </div>
                <div className="flex gap-3 bg-white/[0.02] border border-white/5 rounded-xl p-3.5">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">3</span>
                  <div>
                    <h5 className="text-sm font-bold text-white mb-0.5">Registra los datos de la sub-agencia</h5>
                    <p className="text-sm text-slate-300 leading-relaxed">Completa nombre, correo y datos de contacto del sub-agente. Según tu plan se cobra el costo de registro (Starter $79 · Duo $59 · Profesional $39 · Travel Empire gratis e ilimitado).</p>
                  </div>
                </div>
                <div className="flex gap-3 bg-white/[0.02] border border-white/5 rounded-xl p-3.5">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">4</span>
                  <div>
                    <h5 className="text-sm font-bold text-white mb-0.5">El sistema aplica el mark up oculto</h5>
                    <p className="text-sm text-slate-300 leading-relaxed">Al crear la sub-agencia, el diferencial (comisión/mark up "escondido") queda incluido automáticamente en el precio de los hoteles. No tienes que configurar nada.</p>
                  </div>
                </div>
                <div className="flex gap-3 bg-white/[0.02] border border-white/5 rounded-xl p-3.5">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">5</span>
                  <div>
                    <h5 className="text-sm font-bold text-white mb-0.5">Entrega el acceso al sub-agente</h5>
                    <p className="text-sm text-slate-300 leading-relaxed">Comparte las credenciales con tu sub-agente. Ya puede entrar a buscar y reservar hoteles con las tarifas de la plataforma.</p>
                  </div>
                </div>
                <div className="flex gap-3 bg-white/[0.02] border border-white/5 rounded-xl p-3.5">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#00A9CE] text-[#04283a] font-black text-sm flex items-center justify-center">6</span>
                  <div>
                    <h5 className="text-sm font-bold text-white mb-0.5">El sub-agente compra o vende</h5>
                    <p className="text-sm text-slate-300 leading-relaxed">Puede comprar a <strong className="text-white">precio neto</strong> (comisión cero) o agregar su propio mark up y vender más caro, quedándose con esa diferencia como ganancia.</p>
                  </div>
                </div>
                <div className="flex gap-3 bg-[#C9A84C]/10 border border-[#C9A84C]/25 rounded-xl p-3.5">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#E0B835] text-[#04283a] font-black text-sm flex items-center justify-center">7</span>
                  <div>
                    <h5 className="text-sm font-bold text-white mb-0.5">Cobras tus ganancias</h5>
                    <p className="text-sm text-slate-200 leading-relaxed">El diferencial se reparte entre Club Viajemos y tú según tu plan (Starter 50/50 · Duo 55/45 · Profesional 60/40 · Travel Empire 80/20). Los pagos se hacen al <strong className="text-white">final del mes siguiente</strong> a la fecha de check-out de cada reserva.</p>
                  </div>
                </div>
              </div>

              <div className="mt-4 flex items-start gap-2 bg-[#00A9CE]/10 border border-[#00A9CE]/25 rounded-xl p-3.5">
                <Sparkles className="h-4 w-4 text-[#00A9CE] flex-shrink-0 mt-0.5" />
                <p className="text-sm text-slate-200 leading-relaxed">
                  <strong className="text-white">Tip:</strong> mientras más sub-agencias abras, más volumen de reservas generas y más ganas por el diferencial. En el plan <strong className="text-[#E0B835]">Travel Empire</strong> el registro es gratis e ilimitado y te quedas con el 80% del diferencial.
                </p>
              </div>
            </div>

          </div>


          {/* TÉRMINOS Y CONDICIONES · Cláusula de reservas */}
          <div id="ratehawk-terminos" data-testid="ratehawk-terminos" className="mt-10 bg-[#0a0a14] border border-white/10 rounded-2xl p-6 sm:p-8 scroll-mt-24">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-xl bg-white/5 border border-white/15 flex items-center justify-center flex-shrink-0">
                <ScrollText className="h-5 w-5 text-[#C9A84C]" />
              </div>
              <div>
                <p className="text-[10px] text-[#C9A84C] font-mono tracking-[2px] uppercase">Términos y Condiciones</p>
                <h3 className="text-xl sm:text-2xl font-black text-white leading-tight">Condiciones mínimas de reserva y comisiones</h3>
              </div>
            </div>
            <ReservaCondicionesContenido plain={true} />
            <p className="mt-6 text-xs text-slate-400 leading-relaxed border-t border-white/10 pt-4">
              Estas condiciones rigen para todas las reservas realizadas desde el 1 de enero de 2026. Última actualización: 19 de octubre de 2026.
            </p>
          </div>

          <p className="mt-6 text-center text-xs text-slate-500 italic">
            <Sparkles className="inline h-3 w-3 text-slate-600 mr-1 mb-0.5" />
            Próximamente: más tutoriales, videos y guías paso a paso de RateHawk.
          </p>
        </div>
      </section>
      )}

      {/* ORANGE · Seguros de viaje (curso) */}
      <section className="px-4 pt-6 pb-2">
        <div className="max-w-6xl mx-auto">
          <AccordionCard
            Icon={Umbrella}
            accent="#F97316"
            testid="academia-card-orange"
            badge="Plataforma · Seguros de viaje"
            title="Curso ORANGE · Club Viajemos"
            desc="Cómo crear un voucher y manejar la plataforma de seguros de viaje, paso a paso."
            open={!!open.orange}
            onToggle={() => toggle("orange")}
          />
        </div>
      </section>
      {open.orange && <OrangeSegurosSection />}

      {/* Videos que hacen dinero */}
      <section className="px-4 pt-6 pb-2">
        <div className="max-w-6xl mx-auto">
          <AccordionCard
            Icon={Video}
            accent="#EF4444"
            testid="academia-card-videos"
            badge="Biblioteca · Videos"
            title="Videos que hacen dinero"
            desc="Grabaciones y clips clave para vender más. Ábrelos cuando quieras estudiarlos."
            open={!!open.videos}
            onToggle={() => toggle("videos")}
          />
        </div>
      </section>
      {open.videos && <MoneyVideosSection />}
      </>)}

      {/* Footer mini */}
      <footer className="py-10 px-4 text-center text-xs text-slate-500 border-t border-white/5">
        <p>&copy; 2025 Club Viajemos / Travel Empire · Carlos Miami Fernandez</p>
        <p className="mt-1">Florida Seller of Travel ST39568 · Surety Bond $25,000</p>
        <p className="mt-3">
          <a href="/" className="text-[#C9A84C] hover:underline">← Volver al sitio principal</a>
        </p>
      </footer>
    </div>
  );
};

export default AcademiaPage;
